/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Not_LockedInputs */

const cs_workflow_not_locked = /** @type {(inputs: Workflow_Not_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow není zamknut vámi`)
};

const en_workflow_not_locked = /** @type {(inputs: Workflow_Not_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The workflow is not locked by you`)
};

/**
* | output |
* | --- |
* | "The workflow is not locked by you" |
*
* @param {Workflow_Not_LockedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_not_locked = /** @type {((inputs?: Workflow_Not_LockedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Not_LockedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_not_locked(inputs)
	return cs_workflow_not_locked(inputs)
});